module.exports = __webpack_public_path__ + "img/185.dfaecf21.jpg";